import * as types from "@common/components/addressMultiple/store/addressMultiple.actionType";

export default {
  getByCep: (data, reference) => ({
    type: types.ADDRESS_MULTIPLE_GET,
    payload: { data, reference }
  }),
  getByCepPorCidade: (data, reference) => ({
    type: types.ADDRESS_MULTIPLE_GETCEPCIDADE,
    payload: { data, reference }
  }),
  setAddress: address => ({
    type: types.ADDRESS_MULTIPLE_SET,
    payload: address
  }),
  resetAddress: () => ({
    type: types.ADDRESS_MULTIPLE_RESET
  }),
  setFilterType: value => ({
    type: types.ADDRESS_MULTIPLE_FILTERTYPE_SET,
    payload: value
  }),
  setHash: hash => ({
    type: types.ADDRESS_MULTIPLE_HASH_SET,
    payload: hash
  })
};